<template>
  <a-card style="border: none; border-radius: 12px; minHeight: 100%">
    <div slot="title" v-if="isAutoEdit && autoSaveShow">
      <a-row type="flex" align="middle" justify="space-between">
        <a-col>
          <div v-if="!dataForm.id">
            <a-breadcrumb>
              <a-breadcrumb-item>人员列表</a-breadcrumb-item>
              <a-breadcrumb-item>
                <a @click="click">人员信息录入</a></a-breadcrumb-item
              >
              <a-breadcrumb-item>{{
                isAutoEdit ? "自动录入" : "手动录入"
              }}</a-breadcrumb-item>
            </a-breadcrumb>
          </div>
          <div v-else-if="disabled">
            <a-breadcrumb>
              <a-breadcrumb-item>人员列表</a-breadcrumb-item>
              <a-breadcrumb-item>信息查看</a-breadcrumb-item>
            </a-breadcrumb>
          </div>
          <div v-else>
            <a-breadcrumb>
              <a-breadcrumb-item>人员列表</a-breadcrumb-item>
              <a-breadcrumb-item>信息编辑</a-breadcrumb-item>
            </a-breadcrumb>
          </div>
        </a-col>
        <a-col>
          <div class="autoSave" v-if="!disabled">
            <a-space>
              <span style="font-size: 14px">刷卡后自动保存:</span>
              <a-switch
                size="large"
                checked-children="开"
                un-checked-children="关"
                v-model="autoSave"
              />
              <a-icon
                type="close-circle"
                class="close"
                @click="autoSaveShow = false"
              />
            </a-space>
          </div>
        </a-col>
      </a-row>
    </div>

    <div class="myForm">
      <a-row :gutter="75" type="flex" justify="center" style="padding: 0 40px">
        <a-col :md="24" :lg="8" v-if="!dataForm.id && isAutoEdit">
          <div class="cardBox" @click="test">
            <img src="@/assets/image/img_sfzsb.png" />
            <div class="msg">请将身份证放入识别区域</div>
          </div>

          <div class="shibieing">
            <div class="valueBox" :style="{ opacity: reading == 0 ? 0 : 1 }">
              <div class="value" :style="{ width: reading + '%' }"></div>
              <div
                class="loadingmsg"
                :style="{ left: `calc(${reading}% - 76px)` }"
              >
                身份证正在识别中···
              </div>
            </div>

            <a-button v-if="!isconnect" @click="initCardSocket" style="margin-bottom: 10px;"
              >重新连接身份证读卡器</a-button
            >
            <a-alert
              v-if="!isconnect"
              message="警告"
              description="身份证读卡器连接异常，请联系管理员"
              type="error"
              show-icon
            />
          </div>
        </a-col>
        <a-col :sm="24" :lg="15">
          <div>
            <a-form-model
              ref="ruleForm"
              :model="dataForm"
              :rules="rules"
              layout="horizontal"
            >
              <a-form-model-item prop="name" ref="name">
                <FormItem label="姓名">
                  <a-input
                    size="large"
                    :disabled="isAutoEdit || disabled"
                    v-model="dataForm.name"
                    placeholder="姓名"
                    @change="
                      () => {
                        $refs.name.onFieldChange();
                      }
                    "
                  />
                </FormItem>
              </a-form-model-item>
              <a-row>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="gender" ref="gender">
                    <FormItem label="性别">
                      <a-select
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                        placeholder="请选择性别"
                        :disabled="isAutoEdit || disabled"
                        size="large"
                        v-model="dataForm.gender"
                        style="width: 100%"
                        @change="
                          () => {
                            $refs.gender.onFieldChange();
                          }
                        "
                        :getPopupContainer="
                          (triggerNode) => {
                            return triggerNode.parentNode || document.body;
                          }
                        "
                      >
                        <a-select-option :value="1"> 男 </a-select-option>
                        <a-select-option :value="2"> 女 </a-select-option>
                        <!-- <a-select-option value="3"> 其他 </a-select-option> -->
                      </a-select>
                    </FormItem>
                  </a-form-model-item>
                </a-col>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="nation" ref="nation">
                    <FormItem label="民族">
                      <a-input
                        size="large"
                        :disabled="isAutoEdit || disabled"
                        v-model="dataForm.nation"
                        placeholder="民族"
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-form-model-item prop="id_no" ref="id_no">
                <FormItem label="身份证号码">
                  <a-input
                    size="large"
                    :disabled="isAutoEdit || disabled"
                    v-model="dataForm.id_no"
                    placeholder="身份证号码"
                    @change="
                      () => {
                        $refs.id_no.onFieldChange();
                      }
                    "
                  />
                </FormItem>
              </a-form-model-item>
              <a-row>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="native_place">
                    <FormItem label="籍贯">
                      <a-input
                        size="large"
                        :disabled="isAutoEdit || disabled"
                        v-model="dataForm.native_place"
                        placeholder="籍贯"
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="birthday">
                    <FormItem label="出生日期">
                      <a-date-picker
                        placeholder="请选择出生日期"
                        :disabled="isAutoEdit || disabled"
                        mode="date"
                        size="large"
                        format="YYYY-MM-DD"
                        v-model="dataForm.birthday"
                        :disabled-date="disabledDate"
                        style="width: 100%"
                        valueFormat="YYYY-MM-DD"
                        @change="
                          () => {
                            $refs.birthday.onFieldChange();
                          }
                        "
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="phone" ref="phone">
                    <FormItem label="联系电话">
                      <a-input
                        size="large"
                        :disabled="disabled"
                        v-model="dataForm.phone"
                        placeholder="联系电话"
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="job_no" ref="job_no">
                    <FormItem label="工号">
                      <a-input
                        size="large"
                        :disabled="disabled"
                        v-model="dataForm.job_no"
                        placeholder="工号"
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="work_type" ref="work_type">
                    <FormItem label="工种">
                      <a-select
                        placeholder="请选择工种"
                        size="large"
                        :disabled="disabled"
                        v-model="dataForm.work_type"
                        :getPopupContainer="
                          (triggerNode) => {
                            return triggerNode.parentNode || document.body;
                          }
                        "
                      >
                        <a-select-option
                          :value="v.id"
                          v-for="v in word_type_arr"
                          :key="v.id"
                        >
                          {{ v.title || "未命名" }}
                        </a-select-option>
                        <!-- <a-select-option value="3"> 其他 </a-select-option> -->
                      </a-select>
                    </FormItem>
                  </a-form-model-item>
                </a-col>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="duties" ref="duties">
                    <FormItem label="职务">
                      <a-input
                        size="large"
                        :disabled="disabled"
                        v-model="dataForm.duties"
                        placeholder="职务"
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="age" ref="age">
                    <FormItem label="年龄">
                      <a-input
                        size="large"
                        :disabled="isAutoEdit || disabled"
                        v-model="dataForm.age"
                        type="number"
                        placeholder="年龄"
                        :bordered="false"
                      />
                    </FormItem>
                  </a-form-model-item>
                </a-col>
                <a-col :md="24" :lg="12">
                  <a-form-model-item prop="company_id" ref="company_id">
                    <FormItem label="所属单位">
                      <a-select
                        size="large"
                        show-search
                        placeholder="请选择所属单位"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-model="dataForm.company_id"
                        :disabled="disabled"
                        @change="
                          () => {
                            $refs.company_id.onFieldChange();
                          }
                        "
                        :getPopupContainer="
                          (triggerNode) => {
                            return triggerNode.parentNode || document.body;
                          }
                        "
                      >
                        <a-select-option
                          :value="v.id"
                          v-for="v in company_arr"
                          :key="v.id"
                        >
                          {{ v.name }}
                        </a-select-option>
                      </a-select>
                    </FormItem>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xl="24" :xxl="12">
                  <a-form-model-item prop="id_front_img" ref="id_front_img">
                    <FormItem label="身份证正面">
                      <div class="idcard">
                        <a-icon
                          class="remove"
                          v-if="dataForm.id_front_img && !disabled"
                          @click="
                            (dataForm.id_front_img = ''),
                              (dataForm.head_photo = '')
                          "
                          type="close-circle"
                          theme="filled"
                        />
                        <img
                          v-if="dataForm.id_front_img"
                          class="carimg"
                          :src="dataForm.id_front_img"
                          alt=""
                          srcset=""
                          @click="showImage(dataForm.id_front_img)"
                        />
                        <a-upload
                          v-if="!dataForm.head_photo && !dataForm.id_front_img"
                          name="file"
                          :multiple="true"
                          :action="$store.state.config.baseURL + '/upload'"
                          :remove="removeFront"
                          @change="handleChangeFront"
                          :disabled="disabled"
                        >
                          <a-tooltip>
                            <template
                              slot="title"
                              v-if="!dataForm.id_front_img && !disabled"
                              >点击进行手动上传图片</template
                            >
                            <img
                              class="nocarimg"
                              src="@/assets/image/img_sfzzm.png"
                              alt=""
                              srcset=""
                            />
                          </a-tooltip>
                        </a-upload>
                        <IdFront
                          v-if="dataForm.head_photo && !dataForm.id_front_img"
                          ref="idFront"
                          :head_photo="dataForm.head_photo"
                          :name="dataForm.name"
                          :gender="dataForm.gender"
                          :nation="dataForm.nation"
                          :birthday="dataForm.birthday"
                          :address="dataForm.address"
                          :no="dataForm.id_no"
                        ></IdFront>
                      </div>
                    </FormItem>
                  </a-form-model-item>
                </a-col>
                <a-col :xl="24" :xxl="12">
                  <a-form-model-item prop="id_back_img" ref="id_back_img">
                    <FormItem label="身份证反面">
                      <div class="idcard">
                        <a-icon
                          class="remove"
                          v-if="dataForm.id_back_img && !disabled"
                          @click="
                            (dataForm.id_back_img = ''),
                              (dataForm.head_photo = '')
                          "
                          type="close-circle"
                          theme="filled"
                        />
                        <img
                          v-if="dataForm.id_back_img"
                          class="carimg"
                          :src="dataForm.id_back_img"
                          alt=""
                          srcset=""
                          @click="showImage(dataForm.id_back_img)"
                        />
                        <a-upload
                          v-if="!dataForm.head_photo && !dataForm.id_back_img"
                          name="file"
                          :multiple="true"
                          :action="$store.state.config.baseURL + '/upload'"
                          :remove="removeBack"
                          @change="handleChangeBack"
                          :disabled="disabled"
                        >
                          <a-tooltip>
                            <template
                              slot="title"
                              v-if="!dataForm.id_back_img && !disabled"
                              >点击进行手动上传图片</template
                            >
                            <img
                              class="nocarimg"
                              src="@/assets/image/img_sfzbm.png"
                              alt=""
                              srcset=""
                            />
                          </a-tooltip>
                        </a-upload>
                        <IdBack
                          v-if="dataForm.head_photo && !dataForm.id_back_img"
                          ref="idBack"
                          :issuer="dataForm.issuer"
                          :valied="dataForm.valied"
                          :expire="dataForm.expire"
                        ></IdBack>
                      </div>
                    </FormItem>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <!-- <a-col :md="24" :lg="12">
                  <FormItem label="人脸录入">
                    <a-button size="large" type="link"> <u>录入人脸 </u> </a-button>
                  </FormItem>
                </a-col> -->
                <a-col :md="24" :lg="12">
                  <FormItem label="指纹录入">
                    <div class="facefinger">
                      <div v-if="dataForm.finger">已录入</div>
                      <a-button
                        size="large"
                        type="link"
                        @click="initFingerImage"
                        :disabled="disabled"
                      >
                        <u>{{ dataForm.finger ? "重新录入" : "录入指纹" }} </u>
                      </a-button>
                    </div>
                  </FormItem>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </a-col>
      </a-row>
      <br />
      <a-row type="flex" justify="space-between" v-if="!autoSave">
        <a-col>
          <div v-if="!dataForm.id">
            <a-button
              size="large"
              type="link"
              @click="isAutoEdit = false"
              v-if="isAutoEdit"
            >
              <u>没带身份证手动录入> </u>
            </a-button>
            <a-button
              size="large"
              type="link"
              @click="isAutoEdit = true"
              v-else
            >
              <u>切换身份证读卡器自动录入> </u>
            </a-button>
          </div>
        </a-col>
        <a-col v-if="!disabled">
          <a-button
            size="large"
            :type="disabled ? 'primary' : ''"
            @click="close"
            >{{ disabled ? "返回" : "关闭" }}</a-button
          >
          <a-button
            v-if="!disabled"
            size="large"
            type="primary"
            :loading="confirmLoading"
            @click="handleOk"
            >{{ dataForm.id ? "保存修改" : "保存信息" }}</a-button
          >
        </a-col>
      </a-row>
      <br />
    </div>
    <AddFinger ref="addFinger" @getImg="getFingerImg"></AddFinger>
    <AutoSavePop
      ref="autoSavePop"
      :confirmLoading="confirmLoading"
      @resetForm="resetForm"
    ></AutoSavePop>
  </a-card>
</template>

<script>
import FormItem from "@/components/FormItem/index";
import moment from "moment";
import {
  configDetailAll,
  addPerson,
  editPerson,
  personInfo,
} from "@/request/person";
import { companyAll } from "@/request/company";
import { upload } from "@/request/sys";
import axios from "axios";
import CardSocketClient from "@/utils/idcard";
import { nation_arr } from "@/utils/config";
import { sixformatDate, calculateAge } from "@/utils/util";
import { dataURLtoBlob } from "@/utils/os";
import AddressParse from "zh-address-parse";
import AddFinger from "./components/addFinger";
import IdFront from "@/components/IdCardFront/index";
import IdBack from "@/components/IdCardBack/index";
import AutoSavePop from "./components/autoSavePop";
export default {
  components: {
    FormItem,
    AddFinger,
    IdFront,
    IdBack,
    AutoSavePop,
  },
  data() {
    return {
      reading: 0,
      disabled: false, //是否全部禁用
      isAutoEdit: true, //是否走身份证识别器读取
      dataForm: {
        id: "",
        name: "", //姓名
        id_no: "", //身份证号
        card_no: "", //卡片编号
        phone: "", //联系电话
        company_id: undefined, //所属单位
        gender: undefined, //性别
        nation: "", //民族
        native_place: "", //籍贯
        address: "", //身份证住址
        birthday: "", //出生日期
        work_type: undefined, //工种
        job_no: "", //工号
        duties: "", //职务
        age: "", //年龄
        head_photo: "",
        id_front_img: "", //身份证正面
        id_back_img: "", //身份证背面
        valied: "", //有效期开始日期
        expire: "", //有效期截止日期
        issuer: "", //签发机关
        finger: "", //指纹图片地址
      },
      confirmLoading: false,
      bf: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "change" }],
        id_no: [
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
        company_id: [
          { required: false, message: "请选择所属单位", trigger: "change" },
        ],
        birthday: [
          { required: true, message: "请选择年龄", trigger: "change" },
        ],
      },
      word_type_arr: [],
      company_arr: [],
      client: null,
      ret: "",
      modal: null,
      finger: null,
      showIdCLose: null,
      isconnect: true, //身份证识别器是否已连接成功
      autoSave: false, //是否自动保存
      autoSaveShow: true,
    };
  },
  created() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
    //所有工种
    configDetailAll({ type: "work_type" }).then((res) => {
      this.word_type_arr = res.data;
    });
    //所有分包单位
    companyAll().then((res) => {
      this.company_arr = res.data;
    });
  },
  mounted() {
    if (this.$route.query.isshow === "1") {
      this.disabled = true;
    }
    if (this.$route.query.id) {
      this.isAutoEdit = false;
      this.dataForm.id = this.$route.query.id;
      personInfo(this.$route.query.id, this.$route.query.project_id).then(
        (res) => {
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        }
      );
    } else {
      this.initCardSocket();
    }
  },
  // watch: {
  //   ret: {
  //     handler(newValue, oldValue) {
  //       if (newValue == 1) {
  //         const h = this.$createElement;
  //         this.modal = this.$confirm({
  //           title: "身份证读卡器未连接",
  //           getContainer: ()=> document.getElementById("bodyContnet"),
  //           content: h("div", {}, [
  //             h(
  //               "p",
  //               "1.请将设备插到电脑主板的USB接口上，不要插在USB拓展设备上，并确保设备数据线两端连接稳固。"
  //             ),
  //             h("p", "2.笔记本电脑须连接电源才能保障USB接口供电充足"),
  //           ]),
  //           onOk() {
  //             console.log("OK");
  //           },
  //           onCancel() {
  //             console.log("Cancel");
  //           },
  //         });
  //       } else {
  //         try {
  //           if (this.modal) this.modal.destroy();
  //         } catch (e) {
  //           console.log(e);
  //           e = null;
  //         }
  //       }
  //     },
  //   },
  // },
  beforeDestroy() {
    if (this.client) {
      this.client.close();
      this.client = null;
    }
  },
  methods: {
    click() {
      this.$router.push("/person/person");
    },
    showImage(img) {
      this.$viewerApi({
        images: [img],
      });
    },
    //指纹回调
    getFingerImg(url) {
      this.dataForm.finger = url;
    },
    test() {
      // this.client.send({
      //   function: "findcard",
      //   module: "idcard",
      //   msgid: "20000",
      // });
    },
    //初始化指纹读取器
    initFingerImage() {
      this.$refs.addFinger.init();
    },
    //指纹成功回调
    setSuccessCallback(res) {
      console.log(res);
    },
    //重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
    },
    //初始化读卡器
    initCardSocket() {
      this.client = new CardSocketClient();
      this.client.connect();
      this.resetForm();
      // 设置回调函数来处理收到的消息
      this.client.setDataCallback((res) => {
        if (this.confirmLoading) return;
        if (this.autoSave) {
          this.confirmLoading = true;
          this.$refs.autoSavePop.init();
        }
        if (
          this.dataForm.id &&
          this.dataForm.name &&
          res.name != this.dataForm.name
        ) {
          return this.$warning({
            title: `当前正在编辑【${this.dataForm.name}】的信息，请勿扫描他人的身份证卡片`,
            content: "请谨慎编辑用户信息，可点击左下角切换为手动录入",
            getContainer: ()=> document.getElementById("bodyContnet"),
          });
        }
        this.reading = 100;
        let a = setTimeout(() => {
          clearTimeout(a);
          this.reading = 0;
          if (!this.autoSave) this.$message.success("读卡成功");
          const nation = nation_arr.find((v) => v.id == res.NationCode);
          // console.log("读卡数据回调", res);
          this.dataForm.name = res.Name; //姓名
          this.dataForm.id_no = res.IDNumber; //身份证号码
          this.dataForm.gender = res.Sex == "男" ? 1 : 2; //性别
          this.dataForm.nation = nation ? nation.name : ""; //民族
          this.dataForm.address = res.Address; //身份证住址
          this.dataForm.birthday = sixformatDate(res.Birthday); //生日
          this.dataForm.age = calculateAge(this.dataForm.birthday); //年龄
          const addrInfo = this.getNativePlace(res.Address); //解析地址
          this.dataForm.native_place = addrInfo.province + addrInfo.city; //籍贯
          this.dataForm.head_photo = "data:image/png;base64," + res.Base64Photo; //身份证头像
          this.dataForm.id_front_img = "";
          this.dataForm.id_back_img = "";
          this.dataForm.issuer = res.IDIssued; //签发机关
          this.dataForm.valied = `${res.IssuedData.substring(
            0,
            4
          )}.${res.IssuedData.substring(4, 6)}.${res.IssuedData.substring(
            6,
            9
          )}`; //有效期开始
          this.dataForm.expire =
            res.ValidDate == "长期"
              ? res.ValidDate
              : `${res.ValidDate.substring(0, 3)}.${res.ValidDate.substring(
                  4,
                  6
                )}.${res.ValidDate.substring(6, 9)}`; //有效期结束
          if (this.autoSave) {
            this.$nextTick(() => {
              this.handleOk();
            });
          }
        }, 500);
      });
      // 读取到身份证编号回调
      this.client.setSnrCallback((res) => {
        // console.log("读取到身份证编号回调", res);
        this.dataForm.card_no = res.idsnr;
      });
      // 设备状态发生变化
      this.client.setCodeCallback((res) => {
        this.isconnect = res.isconnect;
        try {
          if (res.isconnect) {
            this.$message.success("身份证读卡器连接成功");
            if (this.showIdCLose) this.$destroyAll();
            this.showIdCLose = null;
          } else {
            if (this.showIdCLose) return;
            const h = this.$createElement;
            this.showIdCLose = this.$confirm({
              title: "身份证读卡器未连接",
              cancelText: "不再提醒",
              okText: "再次连接",
              getContainer: ()=> document.getElementById("bodyContnet"),
              content: h("div", {}, [
                h(
                  "p",
                  "1.请将设备插到电脑主板的USB接口上，不要插在USB拓展设备上，并确保设备数据线两端连接稳固。"
                ),
                h("p", "2.笔记本电脑须连接电源才能保障USB接口供电充足"),
              ]),
              onOk: () => {
                this.showIdCLose = null;
              },
              onCancel: () => {},
            });
          }
        } catch (e) {
          console.log(e);
          console.log(res, "异常时返回的数据");
        }
      });
      this.client.setErrorCallback((res) => {
        this.$message.error(res.msg);
      });
      //读卡器本地服务器不在线
      this.client.setCloseCallback(() => {
        this.isconnect = false;
        this.$error({
          getContainer: ()=> document.getElementById("bodyContnet"),
          title: "身份证读卡器服务未启动",
          content: "请打开【身份证阅读服务应用程序】或保持在后台",
        });
      });
    },
    removeFront(e) {
      this.dataForm.head_photo = "";
      this.dataForm.id_front_img = "";
    },
    handleChangeFront(info) {
      if (info.file.status == "done") {
        this.dataForm.id_front_img = info.file.response.data.url;
      }
    },
    removeBack(e) {
      this.dataForm.id_back_img = "";
    },
    handleChangeBack(info) {
      if (info.file.status == "done") {
        this.dataForm.id_back_img = info.file.response.data.url;
      }
    },
    getNativePlace(address) {
      const options = {
        type: 0, // 哪种方式解析，0：正则，1：树查找
        textFilter: [], // 预清洗的字段
        nameMaxLength: 8, // 查找最大的中文名字长度
        extraGovData: {
          city: [{ name: "name", code: "code", provinceCode: "provinceCode" }],
          province: [{ name: "name", code: "code" }],
          area: [
            {
              name: "name",
              code: "code",
              provinceCode: "provinceCode",
              cityCode: "cityCode",
            },
          ],
        },
      };
      // type参数0表示使用正则解析，1表示采用树查找, textFilter地址预清洗过滤字段。
      const parseResult = AddressParse(address, options);
      return parseResult;
    },
    handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          let dataForm = JSON.parse(JSON.stringify(this.dataForm));
          //是否有刷卡后的base64的身份证头像
          if (dataForm.head_photo && !dataForm.id) {
            // 头像上传
            const headUp = new Promise(async (resolve, reject) => {
              try {
                let head_photo = await this.base64Upload(
                  dataForm.head_photo,
                  dataForm.name + "身份证头像.png"
                );
                dataForm.head_photo = head_photo.data.url;
                resolve();
              } catch (e) {
                console.log(e, 1);
                // this.$message.error("身份证头像上传失败, 请重试");
                // this.confirmLoading = false;
                reject(new Error("身份证头像上传失败, 请重试"));
              }
            });
            // 身份证正面上传
            const frontUp = new Promise(async (resolve, reject) => {
              try {
                let front = await this.$refs.idFront.getImage();
                let frontUrl = await this.base64Upload(
                  front,
                  dataForm.name + "身份证正面.png"
                );
                dataForm.id_front_img = frontUrl.data.url;
                resolve();
              } catch (e) {
                console.log(e, 2);
                // this.$message.error("身份证正面上传失败, 请重试");
                // this.confirmLoading = false;
                reject(new Error("身份证正面上传失败, 请重试"));
              }
            });
            // 身份证反面上传
            const backUp = new Promise(async (resolve, reject) => {
              try {
                let back = await this.$refs.idBack.getImage();
                let backUrl = await this.base64Upload(
                  back,
                  dataForm.name + "身份证反面.png"
                );
                dataForm.id_back_img = backUrl.data.url;
                resolve();
              } catch (e) {
                console.log(e, 3);
                // this.$message.error("身份证反面上传失败, 请重试");
                // this.confirmLoading = false;
                reject(new Error("身份证反面上传失败, 请重试"));
              }
            });
            try {
              const results = await Promise.all([headUp, frontUp, backUp]);
              console.log(results, "三个异步都成功");
            } catch (e) {
              console.log("三个异步失败", e);
              this.confirmLoading = false;
              return this.$message.error(e.message);
            }
          }
          console.log(dataForm);
          const fn = dataForm.id ? editPerson : addPerson;
          fn(dataForm)
            .then(() => {
              if (this.autoSave) {
                this.$refs.autoSavePop.result({
                  code: 0,
                  message: "新增人员成功",
                  data: dataForm,
                });
              } else {
                this.$message.success(
                  dataForm.id ? "修改人员成功" : "新增人员成功"
                );
              }
              if (!dataForm.id) {
                this.resetForm();
              }
            })
            .catch((err) => {
              this.$refs.autoSavePop.result({
                code: 1,
                message: err.data.message,
              });
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    close() {
      this.$router.history.go(-1);
    },
    //base64图片上传服务器返回url地址
    base64Upload(base64, name) {
      return new Promise((resovle, reject) => {
        const file = dataURLtoBlob(base64, encodeURIComponent(name));
        let formData = new FormData();
        formData.append("file", file);
        upload(formData).then((res) => {
          resovle(res);
        });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },
  },
};
</script>

<style scoped lang="scss">
.cardBox {
  /* width: 380px; */
  height: 380px;
  background: #f5f6fa;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  padding: 20px 0;

  img {
    width: 70%;
    max-height: 100%;
  }

  .msg {
    font-size: 16px;
    font-weight: 600;
    color: #011733;
    margin-top: 70px;
  }
}

.left {
  padding: 20px 30px;
  box-sizing: border-box;
}

.idcard {
  min-height: 150px;
  background: #fafbff;
  border: 1px solid #f5f6fa;
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .remove {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 24px;
    color: #c8c8cc;
    cursor: pointer;
    z-index: 200;
  }

  .carimg {
    width: 326px;
    height: 206px;
    object-fit: cover;
    cursor: pointer;
  }
  .nocarimg {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
  }
}

.shibieing {
  margin: 100px 0;

  .valueBox {
    width: 100%;
    height: 16px;
    background: #f5f6fa;
    opacity: 1;
    border-radius: 10px;
    position: relative;

    .value {
      transition: all 0.5s;
      height: 16px;
      background: #0073ff;
      border-radius: 10px;
    }

    .loadingmsg {
      position: absolute;
      transition: all 0.5s;
      width: 152px;
      height: 24px;
      background: #0073ff;
      top: -40px;
      text-align: center;
      color: #fff;
      line-height: 24px;
      font-size: 14px;
      border-radius: 4px;
    }

    .loadingmsg::after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 24px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid #0073ff;
    }
  }
}
.facefinger {
  height: 54px;
  background: #fafbff;
  border: 1px solid #f5f6fa;
  border-radius: 4px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.autoSave {
  // display: flex;
  // align-items: center;
  span {
    margin-right: 12px;
  }
  .close {
    cursor: pointer;
    font-size: 16px;
    color: #ccc;
  }
}
#myForm {
  width: 100%;
  height: 100%;
}
</style>